import { __extends, __read, __rest, __spreadArray } from "tslib";
import { parseAnimationOption } from '../../animation';
import { GUI } from '../../core/gui';
import { deepAssign, filterTransform, ifShow, sampling, select, subObjects } from '../../util';
import { AXIS_BASE_DEFAULT_CFG, CLASS_NAMES } from './constant';
import { renderGrid } from './guides/axisGrid';
import { renderLabels } from './guides/axisLabels';
import { renderAxisLine } from './guides/axisLine';
import { renderTicks } from './guides/axisTicks';
import { renderTitle } from './guides/axisTitle';
var Axis = /** @class */ (function (_super) {
    __extends(Axis, _super);
    function Axis(options) {
        return _super.call(this, deepAssign({}, AXIS_BASE_DEFAULT_CFG, options)) || this;
    }
    Axis.prototype.render = function (attributes, container, specificAnimation) {
        var _a = filterTransform(attributes), type = _a.type, data = _a.data, className = _a.class, _b = _a.dataThreshold, dataThreshold = _b === void 0 ? 100 : _b, crossSize = _a.crossSize, animate = _a.animate, title = _a.title, showTitle = _a.showTitle, titleSpacing = _a.titleSpacing, truncRange = _a.truncRange, truncShape = _a.truncShape, showLine = _a.showLine, lineExtension = _a.lineExtension, lineArrow = _a.lineArrow, lineArrowOffset = _a.lineArrowOffset, lineArrowSize = _a.lineArrowSize, showTick = _a.showTick, tickDirection = _a.tickDirection, tickLength = _a.tickLength, tickFilter = _a.tickFilter, tickFormatter = _a.tickFormatter, showLabel = _a.showLabel, labelAlign = _a.labelAlign, labelDirection = _a.labelDirection, labelSpacing = _a.labelSpacing, labelFilter = _a.labelFilter, labelFormatter = _a.labelFormatter, labelTransforms = _a.labelTransforms, showGrid = _a.showGrid, gridFilter = _a.gridFilter, gridLength = _a.gridLength, restCfg = __rest(_a, ["type", "data", "class", "dataThreshold", "crossSize", "animate", "title", "showTitle", "titleSpacing", "truncRange", "truncShape", "showLine", "lineExtension", "lineArrow", "lineArrowOffset", "lineArrowSize", "showTick", "tickDirection", "tickLength", "tickFilter", "tickFormatter", "showLabel", "labelAlign", "labelDirection", "labelSpacing", "labelFilter", "labelFormatter", "labelTransforms", "showGrid", "gridFilter", "gridLength"]);
        var restStyle = (function () {
            if (type === 'linear') {
                var _a = restCfg, startPos = _a.startPos, endPos = _a.endPos, rest_1 = __rest(_a, ["startPos", "endPos"]);
                return rest_1;
            }
            var _b = restCfg, angleRange = _b.angleRange, radius = _b.radius, center = _b.center, rest = __rest(_b, ["angleRange", "radius", "center"]);
            return rest;
        })();
        var _c = __read(subObjects(restStyle, [
            'title',
            'line',
            'tick',
            'label',
            'grid',
        ]), 5), titleStyle = _c[0], lineStyle = _c[1], tickStyle = _c[2], labelStyle = _c[3], gridStyle = _c[4];
        var sampledData = sampling(data, dataThreshold).filter(function (_a) {
            var value = _a.value;
            if (truncRange && value > truncRange[0] && value < truncRange[1])
                return false;
            return true;
        });
        var finalAnimation = parseAnimationOption(specificAnimation === undefined ? animate : specificAnimation);
        /** grid */
        var axisGridGroup = select(container).maybeAppendByClassName(CLASS_NAMES.gridGroup, 'g');
        ifShow(showGrid, axisGridGroup, function (group) { return renderGrid(group, sampledData, attributes, gridStyle, finalAnimation); });
        /** main group */
        var axisMainGroup = select(container).maybeAppendByClassName(CLASS_NAMES.mainGroup, 'g');
        /** line */
        var axisLineGroup = axisMainGroup.maybeAppendByClassName(CLASS_NAMES.lineGroup, 'g');
        var lineTransitions = ifShow(showLine, axisLineGroup, function (group) {
            return renderAxisLine(group, attributes, lineStyle, finalAnimation);
        }) || [];
        /** tick */
        var axisTickGroup = axisMainGroup.maybeAppendByClassName(CLASS_NAMES.tickGroup, 'g');
        var tickTransitions = ifShow(showTick, axisTickGroup, function (group) {
            return renderTicks(group, sampledData, attributes, tickStyle, finalAnimation);
        }) || [];
        /** label */
        var axisLabelGroup = axisMainGroup.maybeAppendByClassName(CLASS_NAMES.labelGroup, 'g');
        var labelTransitions = ifShow(showLabel, axisLabelGroup, function (group) {
            return renderLabels(group, sampledData, attributes, labelStyle, finalAnimation);
        }) || [];
        /** title */
        var axisTitleGroup = select(container).maybeAppendByClassName(CLASS_NAMES.titleGroup, 'g');
        var titleTransition = ifShow(showTitle, axisTitleGroup, function (group) {
            return renderTitle(group, select(container), attributes, titleStyle, finalAnimation);
        });
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(lineTransitions), false), __read(tickTransitions), false), __read(labelTransitions), false), [titleTransition], false).filter(function (t) { return !!t; });
    };
    return Axis;
}(GUI));
export { Axis };
//# sourceMappingURL=axis.js.map